<template>
    <div>

        <div class="vx-row mb-4">
            <div class="vx-col w-full text-right">
            <vs-button color="success" type="filled" class="mr-4">Verifikasi</vs-button>
            <vs-button color="danger" type="filled">Kembali</vs-button>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full lg:w-8/12">
                <vx-card class="mb-base" style="height: 80%">
                    <h5 class="mb-2">Detail Pasien</h5>

                    <vs-row class="mt-4">
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">Nama Pasien</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">: {{detailData.patient.name}}</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">Tanggal Visit</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">: {{detailData.visitDate}}</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">Jenis Kelamin</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">: {{detailData.patient.genderName}}</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">Status</label>
                        </vs-col>
                        <vs-col class="w-1/2 lg:w-1/4">
                            <label class="vs-radio--label">: {{detailData.testStatusName}}</label>
                        </vs-col>
                    </vs-row>
                </vx-card>
            </div>
            <div class="vx-col w-full lg:w-4/12">
                <vx-card class="mb-base" style="height: 80%">
                    <h6 class="mb-2">Catatan</h6>

                    <vs-textarea v-model="catatan" rows="2" />
                </vx-card>
            </div>
        </div>

        <vx-card class="mb-base">
            <div>
                <div class="vx-row">
                    <div class="vx-col w-full mt-2 mb-2 flex">

                        <vs-tabs>
                            <vs-tab v-for="tab in detailData.groupTest" :label="tab.name">
                                <div class="tab-text">

                                    <vs-row class="mb-4 mt-4" style="border-bottom: 1px solid #d0d0d0">
                                        <vs-col class="w-1/2 lg:w-5/12">
                                            <label class="vs-radio--label">Test</label>
                                        </vs-col>
                                        <vs-col class="w-1/2 lg:w-3/12 text-center">
                                            <label class="vs-radio--label">Hasil</label>
                                        </vs-col>
                                        <vs-col class="w-1/2 lg:w-2/12 text-center">
                                            <label class="vs-radio--label">Unit</label>
                                        </vs-col>
                                        <vs-col class="w-1/2 lg:w-2/12 text-center">
                                            <label class="vs-radio--label">Nilai Normal</label>
                                        </vs-col>
                                    </vs-row>

                                    <vs-row v-for="(tabTest,idx) in tab.test" :key="idx" class="mb-4">
                                        <vs-col class="w-1/2 lg:w-5/12">
                                            <label class="vs-radio--label">{{tabTest.name}}</label>
                                        </vs-col>
                                        <vs-col class="w-1/2 lg:w-3/12 text-center">
                                            <div class="centerx default-input">
                                                <vs-input class="inputx" placeholder="Result" v-model="detailData.result[idx].result" />
                                            </div>
                                        </vs-col>
                                        <vs-col class="w-1/2 lg:w-2/12 text-center">
                                            <label class="vs-radio--label">{{detailData.result[idx].measure.unit}}</label>
                                        </vs-col>
                                        <vs-col class="w-1/2 lg:w-2/12 text-center">
                                            <label class="vs-radio--label">{{getMeasureRange(detailData.result[idx].measure.measureRanges)}}</label>
                                        </vs-col>
                                    </vs-row>


                                </div>
                            </vs-tab>
                        </vs-tabs>

                    </div>
                </div>
            </div>
        </vx-card>
    </div>
    </div>
</template>

<script>
    import visit from "@/api/visit";

    export default {
        data() {
            return {
                detailData: null,
                catatan: ''
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            async getData() {
                const frms = await visit.getDetail('44691');
                this.detailData = frms.data.data[0];
            },
            getMeasureRange(measureRangeVal) {
                for(let a = 0; a < measureRangeVal.length; a++) {
                    if(measureRangeVal[a].genderId === this.detailData.patient.genderId) {
                        if(measureRangeVal[a].rangeUpper === null) {
                            return measureRangeVal[a].rangeLower;
                        }

                        return measureRangeVal[a].rangeLower + ' - ' + measureRangeVal[a].rangeUpper;
                    }
                }
            }
        }
    }
</script>